import { render, staticRenderFns } from "./previewImg.vue?vue&type=template&id=730baf6b&scoped=true&"
import script from "./previewImg.vue?vue&type=script&lang=js&"
export * from "./previewImg.vue?vue&type=script&lang=js&"
import style0 from "./previewImg.vue?vue&type=style&index=0&id=730baf6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730baf6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('730baf6b')) {
      api.createRecord('730baf6b', component.options)
    } else {
      api.reload('730baf6b', component.options)
    }
    module.hot.accept("./previewImg.vue?vue&type=template&id=730baf6b&scoped=true&", function () {
      api.rerender('730baf6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/previewImg.vue"
export default component.exports